import { useState, useEffect } from 'react';
import { fetchUserProfile, updateUserProfile } from '../controller/user-controller';
import { useAtom } from 'jotai';
import { userAtom } from '../../../../atoms/authAtoms';
import { isAdmin, isAuthenticated } from '../../../../login/controller/login-controller';

export const usePermissionViewModel = (menuKey) => {
  const [user, setUser] = useAtom(userAtom);
  const [permission,setPermission] = useState([])



   function getActionsForMenu(menuKey) {
      const permissions = user?.permissions || [];

    return permissions.reduce((acc, perm) => {
    const prefix = `Menu_${menuKey}_`;
    if (perm.startsWith(prefix)) {
      const action = perm.slice(prefix.length);
      acc.push(action);
    }
    return acc;
  }, []);  
 }




  const hasPermission = (permissionKey,menu='') => {
    if(!isAdmin()){
      if (menu) {
        const actions = getActionsForMenu(menu) || [];
        return actions.includes(permissionKey);
      }
      return Array.isArray(permission) && permission.includes(permissionKey);
    }
   return true
  };


  useEffect(() => {
    if (user&&!isAdmin() && menuKey) {
      const actions = getActionsForMenu(menuKey);
       setPermission(actions)

    }
  }, [user]);



  return {
    permission,
    hasPermission
    };
};